(function () {
  'use strict';

  var POPUP_SELECTOR = '[data-kr-newsletter-popup]';
  var BODY_OPEN_CLASS = 'kr-newsletter-popup-open';

  function getStorageKey(popup) {
    return 'kr-newsletter-popup-' + popup.dataset.sectionId;
  }

  function getSubscribedKey(popup) {
    return getStorageKey(popup) + '-subscribed';
  }

  function getCloseButtons(popup) {
    return popup.querySelectorAll('[data-kr-popup-close]');
  }

  function isDesignMode(popup) {
    return popup.dataset.designMode === 'true';
  }

  function hasSuccessState(popup) {
    return Boolean(
      popup.querySelector('[data-kr-newsletter-success]')
    );
  }

  function safelyGetStorage(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safelySetStorage(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function shouldShowPopup(popup) {
    var frequency;
    var storageKey;
    var storedValue;
    var lastClosedAt;
    var days;
    var duration;

    if (isDesignMode(popup)) {
      return false;
    }

    if (popup.dataset.enabled !== 'true') {
      return false;
    }

    if (
      safelyGetStorage(
        window.localStorage,
        getSubscribedKey(popup)
      )
    ) {
      return false;
    }

    frequency = popup.dataset.frequency || 'days';
    storageKey = getStorageKey(popup);

    if (frequency === 'always') {
      return true;
    }

    if (frequency === 'session') {
      return !safelyGetStorage(
        window.sessionStorage,
        storageKey
      );
    }

    storedValue = safelyGetStorage(
      window.localStorage,
      storageKey
    );

    if (!storedValue) {
      return true;
    }

    if (frequency === 'once') {
      return false;
    }

    if (frequency === 'days') {
      lastClosedAt = Number(storedValue);
      days = Number(popup.dataset.days || 15);
      duration = days * 24 * 60 * 60 * 1000;

      if (!isFinite(lastClosedAt)) {
        return true;
      }

      return Date.now() - lastClosedAt >= duration;
    }

    return true;
  }

  function rememberPopup(popup) {
    var frequency;
    var storageKey;

    if (isDesignMode(popup)) {
      return;
    }

    frequency = popup.dataset.frequency || 'days';
    storageKey = getStorageKey(popup);

    if (frequency === 'always') {
      return;
    }

    if (frequency === 'session') {
      safelySetStorage(
        window.sessionStorage,
        storageKey,
        'true'
      );

      return;
    }

    if (frequency === 'once') {
      safelySetStorage(
        window.localStorage,
        storageKey,
        'true'
      );

      return;
    }

    safelySetStorage(
      window.localStorage,
      storageKey,
      String(Date.now())
    );
  }

  function rememberSubscription(popup) {
    if (isDesignMode(popup)) {
      return;
    }

    safelySetStorage(
      window.localStorage,
      getSubscribedKey(popup),
      'true'
    );
  }

  function openPopup(popup) {
    var dialog;
    var emailInput;

    if (!popup || popup.classList.contains('is-open')) {
      return;
    }

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(function () {
      popup.classList.add('is-open');
      document.body.classList.add(BODY_OPEN_CLASS);

      dialog = popup.querySelector(
        '[data-kr-popup-dialog]'
      );

      emailInput = popup.querySelector(
        'input[type="email"]'
      );

      if (hasSuccessState(popup)) {
        if (dialog) {
          dialog.focus();
        }
      } else if (emailInput) {
        emailInput.focus();
      }
    });
  }

  function closePopup(popup, remember) {
    if (typeof remember === 'undefined') {
      remember = true;
    }

    if (
      !popup ||
      !popup.classList.contains('is-open')
    ) {
      return;
    }

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_OPEN_CLASS);

    if (remember) {
      rememberPopup(popup);
    }

    window.setTimeout(function () {
      if (!popup.classList.contains('is-open')) {
        popup.hidden = true;
      }
    }, 250);
  }

  function copyTextFallback(text) {
    var temporaryInput;

    temporaryInput = document.createElement('textarea');
    temporaryInput.value = text;
    temporaryInput.setAttribute('readonly', '');
    temporaryInput.style.position = 'fixed';
    temporaryInput.style.left = '-9999px';
    temporaryInput.style.opacity = '0';

    document.body.appendChild(temporaryInput);
    temporaryInput.select();

    try {
      document.execCommand('copy');
    } catch (error) {
      return;
    } finally {
      temporaryInput.remove();
    }
  }

  function handleCopyDiscount(popup) {
    var copyButton;
    var codeElement;

    copyButton = popup.querySelector(
      '[data-kr-copy-discount]'
    );

    codeElement = popup.querySelector(
      '[data-kr-discount-code]'
    );

    if (!copyButton || !codeElement) {
      return;
    }

    copyButton.addEventListener('click', function () {
      var code;
      var defaultText;
      var successText;

      code = codeElement.textContent.trim();

      defaultText =
        copyButton.dataset.defaultText ||
        copyButton.textContent;

      successText =
        copyButton.dataset.successText ||
        'Copiado';

      if (
        navigator.clipboard &&
        navigator.clipboard.writeText
      ) {
        navigator.clipboard
          .writeText(code)
          .catch(function () {
            copyTextFallback(code);
          });
      } else {
        copyTextFallback(code);
      }

      copyButton.textContent = successText;

      window.setTimeout(function () {
        copyButton.textContent = defaultText;
      }, 1800);
    });
  }

  function handleKeyboardNavigation(popup) {
    popup.addEventListener('keydown', function (event) {
      var focusableElements;
      var firstElement;
      var lastElement;

      if (event.key === 'Escape') {
        closePopup(popup);
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      focusableElements = popup.querySelectorAll(
        'a[href], ' +
          'button:not([disabled]), ' +
          'input:not([disabled]), ' +
          'select:not([disabled]), ' +
          'textarea:not([disabled]), ' +
          '[tabindex]:not([tabindex="-1"])'
      );

      if (!focusableElements.length) {
        return;
      }

      firstElement = focusableElements[0];

      lastElement =
        focusableElements[
          focusableElements.length - 1
        ];

      if (
        event.shiftKey &&
        document.activeElement === firstElement
      ) {
        event.preventDefault();
        lastElement.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === lastElement
      ) {
        event.preventDefault();
        firstElement.focus();
      }
    });
  }

  function initializePopup(popup) {
    var closeButtons;
    var delay;
    var index;

    if (
      !popup ||
      popup.dataset.krInitialized === 'true'
    ) {
      return;
    }

    popup.dataset.krInitialized = 'true';
    closeButtons = getCloseButtons(popup);

    for (index = 0; index < closeButtons.length; index++) {
      closeButtons[index].addEventListener(
        'click',
        function () {
          closePopup(popup);
        }
      );
    }

    handleCopyDiscount(popup);
    handleKeyboardNavigation(popup);

    if (hasSuccessState(popup)) {
      rememberSubscription(popup);
      openPopup(popup);
      return;
    }

    if (!shouldShowPopup(popup)) {
      popup.hidden = true;
      return;
    }

    delay = Math.max(
      0,
      Number(popup.dataset.delay || 0) * 1000
    );

    window.setTimeout(function () {
      openPopup(popup);
    }, delay);
  }

  function initializeAllPopups(container) {
    var popups;
    var index;

    if (!container) {
      container = document;
    }

    popups = container.querySelectorAll(
      POPUP_SELECTOR
    );

    for (index = 0; index < popups.length; index++) {
      initializePopup(popups[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeAllPopups(document);
      }
    );
  } else {
    initializeAllPopups(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAllPopups(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:select',
    function (event) {
      var popup;

      popup = event.target.querySelector(
        POPUP_SELECTOR
      );

      if (popup) {
        openPopup(popup);
      }
    }
  );

  document.addEventListener(
    'shopify:section:deselect',
    function (event) {
      var popup;

      popup = event.target.querySelector(
        POPUP_SELECTOR
      );

      if (popup) {
        closePopup(popup, false);
      }
    }
  );
})();